export default __webpack_public_path__ + "static/media/homeLoan.9bf4d765.svg";